// rarity.ts — the letter → rarity classification. Shared by the personality effect (to dress tiles)
// and the dictionary (to build the personality test-mode word pool). Kept in core/ so both layers
// can import it without a juice→core dependency inversion.
//
// Rarity is FIXED per letter (identity you learn). The rare Scrabble letters carry the personality;
// the workhorse letters stay common, so most tiles are quiet for free.

export type Rarity = 0 | 1 | 2 | 3; // common · uncommon · rare · epic

export const EPIC_LETTERS = "qzxj";
export const RARE_LETTERS = "kvbwyf";
export const UNCOMMON_LETTERS = "cmpgdh";

const RARITY: Record<string, Rarity> = {};
const set = (letters: string, r: Rarity) => [...letters].forEach((c) => (RARITY[c] = r));
set(EPIC_LETTERS, 3);
set(RARE_LETTERS, 2);
set(UNCOMMON_LETTERS, 1);
// everything else defaults to 0 (common)

export function rarityOf(letter: string): Rarity {
  return RARITY[letter.toLowerCase()] ?? 0;
}

/** How many letters of a word are epic (used to find flirt-pair-rich words for lively-words mode). */
export function epicCount(word: string): number {
  let n = 0;
  for (const c of word.toLowerCase()) if (EPIC_LETTERS.includes(c)) n++;
  return n;
}
